import { MenuProps } from '@mui/material/Menu';

export const menuOpeningTopLeftProps: Pick<MenuProps, 'anchorOrigin' | 'transformOrigin'> = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
};

export const menuOpeningBottomLeftProps: Pick<MenuProps, 'anchorOrigin' | 'transformOrigin'> = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

export const menuOpeningRightProps: Pick<MenuProps, 'anchorOrigin' | 'transformOrigin'> = {
  anchorOrigin: {
    vertical: 'center',
    horizontal: 'right',
  },
  transformOrigin: {
    vertical: 'center',
    horizontal: 'left',
  },
};

export const menuOpeningProps = {
  top: menuOpeningTopLeftProps,
  bottom: menuOpeningBottomLeftProps,
  right: menuOpeningRightProps,
} as const;
